import { render, staticRenderFns } from "./MessageListAndUserInput.vue?vue&type=template&id=548a7454"
import script from "./MessageListAndUserInput.vue?vue&type=script&lang=js"
export * from "./MessageListAndUserInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports